import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _merge from 'lodash/merge';
import Typography from '@material-ui/core/Typography';
import {
    Box, Grid, Card, ListItem,
    CardContent, Button, Avatar, CircularProgress
} from '@material-ui/core';
import {
    useMediaQuery
} from '@material-ui/core';
import { useTranslate, Title, useDataProvider } from 'react-admin';
import colors from '../CustomizedUIs/Colors';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import { baseApiUrl } from '../dataProvider/sails';
import TextField from '../CustomizedUIs/CustomTextFiled';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import Loading from '../common/loading-page';
import TextButton from '../CustomizedUIs/TextButton';
import GreenSwitch from '../CustomizedUIs/GreenSwitch'
import Axios from 'axios';
import { red, pink } from '@material-ui/core/colors';


const bgColorError = pink['50'];
const textColorError = red['700'];



const useStyles = makeStyles(theme => ({
    searchPaper: {
        padding: '4px 2px',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto 0',
    },
    iconButton: {
        padding: 10,
    },
    TitleSwitch: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: '0.36px',
        color: '#4f5064',
    },
    large: {
        width: theme.spacing(12),
        height: theme.spacing(12),
        backgroundColor: '#f3f7fa',
    },
    avatarIcon: {
        width: 40,
        height: 40,
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    display: {
        display: 'none',
    },
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        },
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    number: {
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0
        },
        " & input[type=number] ": {
            "-moz-appearance": "textfield",
        }
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textForce: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#4f5064',
        padding: '5px 8px 5px 8px'
    },
    borderForce: {
        width: '25.5px',
        height: '10.5px',
        backgroundColor: '#b4b5bd',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TitleLevel: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    borderLevel: {
        borderRadius: '10px',
        border: ' solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
    },
    textLevel: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#6cb5b8',
        textAlign: 'center'
    },
    textbtnLevel: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingBottom: '20px'
    },
    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        "&:hover": {
            backgroundColor: '#65a9db'
        },
    },
    textBtnImage: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#237fc2',
        padding: '8px',

    },
    textRequired: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.54)',
    },
    textRequiredStar: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: '#e1503a',
    },

    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    },
    borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
}))

const caretakers = [
    {
        name: 'papa',
        value: "Pappa"
    }, {
        name: 'mama',
        value: "Mamma"
    },
    {
        name: 'faster',
        value: "Faster"
    }
]
export const CreateUser = ({ setCreating, ...props }) => {
    const dataProvider = useDataProvider();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const translate = useTranslate();
    const classes = useStyles();
    const [dataRole, setDataRole] = useState([]);
    const [dataLanguage, setDataLanguage] = useState([]);
    const [openLanguage, setOpenLanguage] = useState(false);
    const [openRelative, setOpenRelative] = useState(false);
    const [relative, setRelative] = useState([]);
    const [role, setRole] = useState();
    const [language, setLanguage] = useState();
    const [avarta, setAvarta] = useState()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [isSuperUser, setSuperUser] = useState(props.super)
    const [messsageError, setMessageError] = useState('')
    const [relatives, setRelatives] = useState([])
    const [textField, setTextField] = React.useState({
        label: {
            userName: translate(`pos.user.username`),
            firstName: translate(`pos.dashboard.name`),
            email: translate(`pos.user.email`),
            phoneNumber: translate(`pos.user.phonenumber`),
        },
        value: {
            userName: '',
            firstName: '',
            email: '',
            phoneNumber: '',
        },
        popperTitle: {
            userName: translate(`pos.user.TitleUsesName`),
            firstName: translate(`pos.user.TitleFirstName`),
            email: translate(`pos.user.TitleEmail`),
            phoneNumber: translate(`pos.user.TitlePhoneNumber`),
        },
        popperContent: {
            userName: translate(`pos.user.ConstentUserName`),
            firstName: translate(`pos.user.ConstentFirstName`),
            email: translate(`pos.user.ConstentEmail`),
            phoneNumber: translate(`pos.user.ConstentPhoneNumber`),
        }
    });

    /**
     * Adds custom fields to the state by transforming the provided custom fields
     * into a structured format and merging them with the existing state.
     *
     * @param {Array<Object>} customFields - An array of custom field objects.
     * @param {string} customFields[].Name - The name of the custom field.
     *
     * The function processes each custom field to generate:
     * - A camelCase key derived from the field name.
     * - Labels, values, popper titles, and popper content for each field.
     *
     * The resulting structured data is merged with the existing `textField` state.
     * Finally, it updates the state and sets the loading state to false.
     */
    const addCustomFieldsToState = (customFields) => {
        const updatedFields = customFields.reduce((acc, field) => {
            const camelCaseFieldName = field?.Name.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (word, index) =>
                index === 0 ? word.toLowerCase() : word.toUpperCase()
            ).replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '');
            return {
                label: {
                    ...acc.label,
                    [camelCaseFieldName]: field?.Name
                },
                value: {
                    ...acc.value,
                    [camelCaseFieldName]: ''
                },
                popperTitle: {
                    ...acc.popperTitle,
                    [camelCaseFieldName]: field?.Name
                },
                popperContent: {
                    ...acc.popperContent,
                    [camelCaseFieldName]: `This is ${field?.Name}`
                }
            };
        }, { label: {}, value: {}, popperTitle: {}, popperContent: {} });
        setTextField(_merge(textField, updatedFields));
        setLoading(false)
    };
    const [validate, setValidate] = React.useState({
        lastName: {
            isError: true,
            message: ''
        },
        number: {
            isError: true,
            message: ''
        },
        userName: {
            isError: true,
            message: ''
        },
        firstName: {
            isError: true,
            message: ''
        }, email: {
            isError: true,
            message: ''
        },
        password: {
            isError: true,
            message: ''
        },
        phoneNumber: {
            isError: true,
            message: ''
        },
        organisation: {
            isError: true,
            message: ''
        }
    });

    const textOnChange = prop => (e) => {
        setTextField({
            ...textField,
            value: {
                ...textField.value,
                [prop]: e.target.value
            }
        })
        validateFc(prop, e.target.value)
    }

    const getRelatives = () => {
        dataProvider('GET_LIST', "relatives", {
            filter: {
                room: { '!=': props.data.id }
            },
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: { field: 'createdAt', order: 'ASC' },

        })
            .then(({ data }) => {
                setRelatives(data)
                handlePickRelative(data[0])

            })
            .catch(error => {
            });
    }

    /**
     * Fetches custom fields from the data provider and updates the state with the results.
     *
     * This function sends a GET request to the 'bokamera/custom-field' endpoint using the data provider.
     * It applies sorting by the 'name' field in ascending order. On a successful response, it adds the
     * retrieved custom fields to the state. If an error occurs, it logs the error and stops the loading state.
     *
     * @function
     * @returns {void}
     */
    const getCustomField = () => {
        setLoading(true);
        dataProvider('GET_LIST', 'bokamera/custom-field', {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        }).then(res => {
            if (res.success) {
                addCustomFieldsToState(res.data.Results);
            }
        }).catch(err => {
            console.log('Get Custom field error: ', err);
            setLoading(false)
        })
    }

    const validateFc = (prop, value) => {
        if (prop === 'userName') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                        isError: false, message: ''
                    }
                })
            else {
                setValidate({
                    ...validate, [prop]: value.length > 50 ? {
                        isError: true, message: translate(`pos.user.error.usernamecharacter`)
                    } : {
                        isError: false, message: ''
                    }
                })
            }
        }
        else if (prop === 'email') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                        isError: false, message: ''
                    }
                })
            else {
                setValidate({
                    ...validate, [prop]: ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(value)) === true ? {
                        isError: false, message: ''
                    } : {
                        isError: true, message: translate('pos.auth.errorEmail')
                    }
                })

            }
        }
        else
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: 'required'
                } : {
                    isError: false, message: ''
                }
            })

    }

    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    // const theme = useSelector((state) =>
    //     state.theme === 'dark' ? darkTheme : lightTheme
    // );



    // event select language
    const handleClickOpenLanguage = () => {
        setOpenLanguage(!openLanguage)
    }
    const onChangeLanguage = (value) => {
        setLanguage(value)
        // setLanguageId(language.id)
        // setLanguageCode(language.code)
        setOpenLanguage(false)
    }

    const handlePickRelative = (item) => {
        setRelative(item)
        setTextField({
            ...textField,
            value: {
                ...textField.value,
                userName: item.userName,
                firstName: item.name,
                email: item.email,
                phoneNumber: item.phoneNumber,
            }
        })
        setAvarta(item.avarta)
        setLanguage(item.language)
        setOpenRelative(false)
    }

    const handleChooseImage = (event) => {
        var files = [...event.target.files]
        var file = files[0]
        const newFile = {
            name: file.name,
            size: file.size,
            file: file,
            error: false,
            loading: false,
            override: false,
            type: file.type
        };
        newFile.fd = URL.createObjectURL(file)
        setAvarta(newFile)
    }
    const handleClosePoper = () => {
        setOpenPopper(false);
    };
    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };


    const assignToRoom = () => {
        setLoading(true)
        dataProvider('CREATE', "relatives/assigntoroom", {
            data: {
                relative: relative.id,
                room: props.data.id,
                role: isSuperUser ? 'super_user' : 'user',
                nickName: props.data.name
            }
        }).then(({ data }) => {
            setCreating(false)
            props.setShowSnackbar({
                status: true,
                name: relative.email,
                message: translate(`pos.relatives.createRelative.success`)

            })
            setTimeout(() => props.setShowSnackbar({ status: false }), 6000)
        })
            .catch(error => {
                if (error.message === 'exist')
                    setMessageError('Relative already exist in room')
                else
                    setMessageError(error.message)
                setLoading(false)
            })
    }

    const handleSubmitUser = () => {
        setLoading(true)
        const config = {
            // onUploadProgress: function (progressEvent) {
            //     var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            //     setProgress(percentCompleted)
            // },
            headers: { token: localStorage.getItem('token') }
        }
        var body = {
            email: textField.value.email,
            userName: textField.value.userName,
            name: textField.value.firstName,
            role: isSuperUser ? 'super_user' : 'user',
            phoneNumber: textField.value.phoneNumber,
            room: props.data.id,
            language: language.id,
            bokameraRelativeTo: textField.value?.relativeTo,
        }
        if (avarta)
            body.file = true
        let data = new FormData()
        data.append('data', JSON.stringify(body))
        if (avarta)
            data.append('file', avarta.file)
        Axios
            .post(`${baseApiUrl}/relatives`, data, config)
            .then(({ data }) => {

                setCreating(false)
                props.setShowSnackbar({
                    status: true,
                    name: data.data.email,
                    message: translate(`pos.relatives.createRelative.success`)

                })
                setTimeout(() => props.setShowSnackbar({ status: false }), 6000)
            })
            .catch(error => {
                if (error.response.data.message === 'notCreateUserFisrt')
                    setMessageError('Can not create first relative with role is User')
                else
                    setMessageError(error.response.data.message)
                setLoading(false)
            })

    };

    const getLanguage = (defaultLanguage) => {
        let language = defaultLanguage ? defaultLanguage[0].value : null
        let code
        switch (language) {
            case 'English':
                code = 'US'
                break;
            case 'Swedish':
                code = 'SE'
                break;
            default:
                code = 'SE'
                break;
        }
        dataProvider('GET_LIST', "language", {
            filter: {

            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setDataLanguage(data);
                setLanguage(data.find(value => value.code === code))
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }

    useEffect(() => {
        var request = []
        var defaultLanguage
        props.assign && getRelatives()
        request.push(dataProvider('GET_LIST', "settings", {
            filter: {
                cluster: null,
                room: null,
                name: 'Default System Language'
            },
            sort: {},
            pagination: {}
        }).then(({ data }) => {
            defaultLanguage = data
        })
        )
        Promise.all(request)
            .then(() => {
                setLoading(false)
                getLanguage(defaultLanguage)
            })
            .catch(() => {
                getLanguage()
                console.log('Error')
            })
        dataProvider('GET_LIST', "rolesList", {
            filter: {},
            pagination: {},
            sort: {},

        })
            .then(({ data }) => {
                setDataRole(data);
                setRole(data.find(value => value.name == 'Admin'))
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });

        dataProvider('GET_LIST', "clusters", {
            filter: {

            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        })
            .then(({ data }) => {
                console.log('[CLUSTER] Response', data);
            }).catch(error => {
                setError(error);
            })
    }, []);

    useEffect(() => {
        if (props.data?.isBokamera) {
            getCustomField();
        }
    }, [props.data])
    // if ( props.assign) return null
    if (!dataRole || !role) return null
    if (!dataLanguage || !language) return null
    if (loading) return <Loading show={true} />;
    if (error) return null;


    return (
        <Box width='100%' >
            <Title className={classes.TitleCreate} title={translate(`pos.user.title`)} />
            <Box width={!isDesktop ? '95%' : '80%'} m='auto'>
                <Box display='flex' width='100%'>
                    <Box my={1} style={{ width: '500px' }} >
                        <Typography className={classes.TitleCreate}> {props?.assign ? translate(`resources.room.assignRelative`) : translate(`pos.user.create`)}</Typography>
                        {
                            messsageError != "" && (
                                <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                                    <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messsageError}</Typography>
                                </Box>
                            )
                        }
                        {
                            props.assign && <Box pt={1} pb={0} mt={1} >
                                <SelectBox
                                    disabled={!relative}
                                    label={'Assign relative'}
                                    value={<Box display='flex' alignItems='center' style={{ marginTop: '-5px' }}>
                                        <Box><Typography className={classes.TexTSelect} >{relative ? relative.email : 'Empty'}</Typography></Box>
                                    </Box>
                                    }
                                    open={openRelative}
                                    handleClick={() => setOpenRelative(!openRelative)}
                                >
                                    {
                                        relatives.map((item, index) => (
                                            <Box key={'relative' + index} className={classes.boxBoder}>
                                                <ListItem style={{ padding: '8px' }} button onClick={() => handlePickRelative(item)}>
                                                    <Box><Typography className={classes.TexTSelect} >{item.email}</Typography></Box>
                                                </ListItem>
                                            </Box>
                                        ))
                                    }
                                </SelectBox>
                            </Box>
                        }

                        {
                            Object.keys(textField.label).map(item => {
                                return (
                                    <Box mt={3}>
                                        <TextField
                                            disabled={props.assign}
                                            required
                                            onBlur={() => {
                                                validateFc(item, textField.value[item])
                                            }}
                                            id="userName"
                                            label={textField.label[item]}
                                            value={textField.value[item]}
                                            error={validate[item]?.message != "" && validate[item]?.isError}
                                            helperText={validate[item]?.message}
                                            onChange={textOnChange(item)}
                                            style={{ width: 500 }}
                                            endDom={
                                                <CustomPoper
                                                    open={openPoper}
                                                    anchorEl={anchorEl}
                                                    handleClick={handleClickOpenPoper}
                                                    handleClose={handleClosePoper}
                                                    title={textField.popperTitle[item]}
                                                    content={textField.popperContent[item]}
                                                    icon={<b>?</b>}
                                                />
                                            } />
                                    </Box>
                                )
                            })
                        }



                        <Box pt={1} pb={0} mt={1} >
                            <SelectBox
                                disabled={props.assign}
                                label={translate(`pos.user.language`)}
                                value={<Box display='flex' alignItems='center' style={{ marginTop: '-5px' }}>
                                    <img alt='' src={`https://www.countryflags.io/${language.code}/flat/32.png`} />
                                    <Box ml={2}><Typography className={classes.TexTSelect} >{language.name}</Typography></Box>
                                </Box>
                                }
                                open={openLanguage}
                                handleClick={handleClickOpenLanguage}
                            >
                                {
                                    dataLanguage.map((Language, index) => (
                                        <Box key={index} className={classes.boxBoder}>
                                            <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLanguage(Language)}>
                                                <img alt='' src={`https://www.countryflags.io/${Language.code}/flat/32.png`} />
                                                <Box ml={2}><Typography className={classes.TexTSelect} >{Language.name}</Typography></Box>
                                            </ListItem>
                                        </Box>
                                    ))
                                }
                            </SelectBox>
                        </Box>
                        <Box display='flex' style={{ opacity: props.super ? 0.5 : 1 }} width='157px' borderRadius={4} bgcolor='background.paper' my={3} px={1} alignItems='center'>
                            <Box flexGrow={1}>
                                <Typography className={classes.TitleSwitch}>{'Super user'.toUpperCase()}</Typography>
                            </Box>
                            <GreenSwitch disabled={props.super} size='small' checked={isSuperUser} onChange={(event) => {
                                setSuperUser(event.target.checked)
                            }}></GreenSwitch>
                        </Box>
                        <Card style={{ marginTop: "1em" }} className={classes.borderUpImange} >
                            <Grid container style={{ marginTop: "1em" }} item xs={12} sm={12} xl={12} lg={12} >
                                <Grid >
                                    <CardContent>
                                        <Avatar src={avarta ? avarta.fd : ""} className={classes.large} classes={{
                                            img: classes.avatarIcon
                                        }} />
                                    </CardContent>

                                </Grid>
                                <Grid>
                                    <CardContent>
                                        <Typography className={classes.TitleImage} gutterBottom>
                                            {translate(`pos.user.changeimage`)}
                                        </Typography>
                                        <Box>
                                            <input disabled={props.assign} accept="image/*" className={classes.display} id="contained-button-file" type='file' onChange={handleChooseImage} />
                                            <label htmlFor="contained-button-file">
                                                <Button variant='contained' color='secondary' component="span" disabled={props.assign}>
                                                    {translate(`pos.user.uploadphoto`)}
                                                </Button>
                                            </label>
                                        </Box>
                                    </CardContent>
                                </Grid>
                            </Grid>
                        </Card>
                        <hr style={{ marginTop: "30px", borderTopColor: ' #e6e6eb' }} />
                        <Box display='flex' justifyContent='flex-end'>
                            <Box mr='auto' display='flex'>
                                <Typography className={classes.textRequiredStar} >{translate(`pos.user.star`)}</Typography>
                                <Typography className={classes.textRequired} >{translate(`pos.user.required`)}</Typography>

                            </Box>
                        </Box>
                        <Box display='flex' justifyContent='flex-end'>
                            <Box display='flex' alignItems='flex-end' mr={3} mt={3}  >
                                <TextButton style={{ marginRight: '30px' }} onClick={() => { setCreating(false) }} />

                                <Button variant="contained" color='primary' size='large' onClick={!props.assign ? handleSubmitUser : assignToRoom}
                                    disabled={textField.value.userName && textField.value.firstName && textField.value.email !== '' ? false : true}
                                >
                                    {loading ? (
                                        <CircularProgress
                                            size={20}
                                            thickness={2}
                                            color='inherit'
                                        />
                                    ) : <Typography className={classes.btnCreate}>  {translate(`pos.user.save`)}</Typography>}
                                </Button>
                            </Box>
                        </Box>

                    </Box>
                </Box>
            </Box>
        </Box>
    )

}
export default CreateUser

